import { useLocation, useParams } from "react-router"
import { customerTypeSchema, productSchema } from "../acquisitionForm/form/useAcquisitionFormSchema"
import { z } from "zod"

export const CUSTOMER_TYPE_PARAM_KEY = "customerType"
export const PRODUCT_PARAM_KEY = "product"
export const CUSTOMER_TYPE_ROUTER_KEY = `:${CUSTOMER_TYPE_PARAM_KEY}`
export const PRODUCT_ROUTER_KEY = `:${PRODUCT_PARAM_KEY}`

export function useCustomerType() {
  const params = useParams()

  const customerTypeRaw = params[CUSTOMER_TYPE_PARAM_KEY]
  const customerType = customerTypeSchema.safeParse(customerTypeRaw)
  if (!customerType.success) {
    return null
  }

  return customerType.data
}

export function useProductParam() {
  const params = useParams()

  const productRaw = params[PRODUCT_PARAM_KEY]
  const product = productSchema.safeParse(productRaw)
  if (!product.success) {
    return null
  }

  return product.data
}

export const dateSchema = z.object({
  date: z.number().min(1).max(31),
  month: z.number().min(0).max(11),
  year: z.number().min(1870).max(9999),
})

export const MAX_FILE_SIZE_MB = 15
export const MAX_FILE_SIZE_B = 1024 * 1024 * MAX_FILE_SIZE_MB

export const fileSchema = z.object({
  name: z.string(),
  lastModified: z.number(),
  type: z.string().refine((value) => value === "application/pdf" || value.startsWith("image/"), {
    message: "Soubor musí být PDF nebo obrázek",
  }),
  size: z.number().max(MAX_FILE_SIZE_B, { message: "Soubor je příliš velký" }),
  bucketPath: z.string().optional(),
})

export function useAcquisitionFormPathname() {
  const { pathname } = useLocation()
  if (pathname.endsWith("/")) {
    return pathname.slice(0, -1)
  }

  return pathname
}
